import {
  Button,
  CircularProgress,
  Grid,
  Snackbar,
  Typography,
} from "@mui/material";
import { useStyles } from "./CustomMessageToastStyle";
import React, { useState } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

interface CustomMessageToastProps {
  open: boolean;
  customMessage: string;
}
export const CustomMessageToast = ({
  open,
  customMessage,
}: CustomMessageToastProps) => {
  const classes = useStyles();
  const [info, setInfo] = useState<boolean>(open);

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setInfo(false);
  };

  const Info = (
    <React.Fragment>
      <Grid container sx={{margin: "1rem auto"}}>
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
          <Typography variant="caption" sx={{fontWeight: 600}}>{customMessage}</Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );

  return (
    <>
      <Snackbar
        className={classes.msgAlignment}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={info}
        // autoHideDuration={6000}
        message={Info}
        onClose={handleClose}
      />
    </>
  );
};
